var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("div", { staticClass: "d-flex align-center" }, [
        _c(
          "div",
          [
            _c("v-icon", { staticClass: "mr-4", attrs: { large: "" } }, [
              _vm._v("mdi-account-details")
            ])
          ],
          1
        ),
        _c("div", { staticClass: "title-header" }, [
          _vm._v("Información del Contacto")
        ])
      ]),
      _c(
        "v-card",
        { staticClass: "pa-4 mb-12" },
        [
          _c(
            "v-form",
            { ref: "form", staticClass: "ma-4" },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: { align: "center", "no-gutters": "" }
                                },
                                [
                                  _c("v-select", {
                                    staticClass: "ml-3",
                                    staticStyle: { "max-width": "45px" },
                                    attrs: {
                                      items: _vm.nationalityOptions,
                                      "offset-y": "",
                                      value: _vm.contact.nationality
                                    },
                                    model: {
                                      value: _vm.contact.nationality,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.contact,
                                          "nationality",
                                          $$v
                                        )
                                      },
                                      expression: "contact.nationality"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "##########",
                                        expression: "'##########'"
                                      }
                                    ],
                                    staticStyle: {
                                      "max-width": "calc(100% - 50px)"
                                    },
                                    attrs: {
                                      rules: [
                                        _vm.rules.required(),
                                        _vm.rules.notEmpty(),
                                        _vm.rules.fieldMinLength(6)
                                      ],
                                      autofocus: "",
                                      "validate-on-blur": "",
                                      label:
                                        "Introduzca su cédula de identidad",
                                      counter: "",
                                      maxlength: "9",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.contact.ci,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.contact,
                                          "ci",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "contact.ci"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  rules: [
                                    _vm.rules.required(),
                                    _vm.rules.notEmpty(),
                                    _vm.rules.email(),
                                    _vm.rules.specialCharacters()
                                  ],
                                  "validate-on-blur": "",
                                  label: "Introduzca su correo electrónico",
                                  counter: "",
                                  maxlength: "100",
                                  required: "",
                                  "prepend-icon": "mdi-at"
                                },
                                model: {
                                  value: _vm.contact.email,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contact,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "contact.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Introduzca su nombre completo",
                                  counter: "",
                                  rules: [
                                    _vm.rules.required(),
                                    _vm.rules.notEmpty(),
                                    _vm.rules.allowLettersExclusively(),
                                    _vm.rules.specialCharacters()
                                  ],
                                  maxlength: "40",
                                  required: "",
                                  "prepend-icon": "mdi-account"
                                },
                                model: {
                                  value: _vm.contact.name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contact,
                                      "name",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "contact.name"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  rules: [
                                    _vm.rules.required(),
                                    _vm.rules.notEmpty(),
                                    _vm.rules.allowLettersExclusively(),
                                    _vm.rules.specialCharacters()
                                  ],
                                  label: "Introduzca su apellido completo",
                                  counter: "",
                                  maxlength: "40",
                                  required: "",
                                  "prepend-icon": "mdi-account"
                                },
                                model: {
                                  value: _vm.contact.lastName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contact,
                                      "lastName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "contact.lastName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("phone-field", {
                                ref: "primaryPhone",
                                attrs: {
                                  "phone-data": _vm.contact.phone,
                                  label: "Introduzca su teléfono primario",
                                  required: ""
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("phone-field", {
                                ref: "secondaryPhone",
                                attrs: {
                                  "phone-data": _vm.contact.cellphone,
                                  label: "Introduzca su teléfono secundario",
                                  required: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                sm: !_vm.showPosition ? 12 : 6
                              }
                            },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: this.CONTACT_TYPES,
                                  "item-value": "id",
                                  "item-text": "name",
                                  "return-object": "",
                                  rules: [
                                    function(v) {
                                      return v != -1 || "Requerido"
                                    }
                                  ],
                                  "no-data-text":
                                    "No se encontraron resultados",
                                  color: "blue-grey lighten-2",
                                  label: "Tipo de Contacto",
                                  "prepend-icon": "mdi-account-tie"
                                },
                                model: {
                                  value: _vm.contact.contactType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.contact, "contactType", $$v)
                                  },
                                  expression: "contact.contactType"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.showPosition
                            ? _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      rules: [
                                        _vm.rules.required(),
                                        _vm.rules.notEmpty(),
                                        _vm.rules.specialCharacters()
                                      ],
                                      label: "Introduzca su cargo",
                                      counter: "",
                                      maxlength: "40",
                                      required: "",
                                      "prepend-icon": "mdi-account-tie"
                                    },
                                    model: {
                                      value: _vm.contact.position,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.contact,
                                          "position",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "contact.position"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  readonly: !this.IS_CONTACT_ADMINISTRATOR,
                                  items: this.RESOURCES,
                                  "item-value": "id",
                                  "item-text": "displayName",
                                  "return-object": "",
                                  rules: [
                                    _vm.rules.required(),
                                    _vm.rules.notEmpty()
                                  ],
                                  "no-data-text":
                                    "No se encontraron resultados",
                                  color: "blue-grey lighten-2",
                                  label: "Privilegios",
                                  "prepend-icon": "mdi-account-tie",
                                  multiple: ""
                                },
                                model: {
                                  value: _vm.selectedResources,
                                  callback: function($$v) {
                                    _vm.selectedResources = $$v
                                  },
                                  expression: "selectedResources"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  "menu-props": { maxWidth: 500 },
                                  items: this.SCALABILITY_LEVELS,
                                  "item-value": "id",
                                  "item-text": "name",
                                  "return-object": "",
                                  rules: [
                                    function(v) {
                                      return v != -1 || "Requerido"
                                    }
                                  ],
                                  "no-data-text":
                                    "No se encontraron resultados",
                                  color: "blue-grey lighten-2",
                                  label: "Nivel de Escalabilidad",
                                  "prepend-icon": "mdi-account-tie"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  data.item.name
                                                )
                                              }
                                            }),
                                            _c("v-list-item-subtitle", {
                                              staticClass: "break-lines",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  data.item.description
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.contact.scalabilityLevel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contact,
                                      "scalabilityLevel",
                                      $$v
                                    )
                                  },
                                  expression: "contact.scalabilityLevel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      !_vm.isUpdating
                        ? _c(
                            "v-form",
                            { ref: "formPassword" },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.passwordRules,
                                          "append-icon": _vm.showPassword
                                            ? "mdi-eye"
                                            : "mdi-eye-off",
                                          type: _vm.showPassword
                                            ? "text"
                                            : "password",
                                          label: "Introduzca su contraseña",
                                          counter: "",
                                          maxlength: "30",
                                          required: "",
                                          autocomplete: "off",
                                          "prepend-icon": "mdi-account-lock"
                                        },
                                        on: {
                                          "click:append": function($event) {
                                            _vm.showPassword = !_vm.showPassword
                                          }
                                        },
                                        model: {
                                          value: _vm.contact.password,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.contact,
                                              "password",
                                              $$v
                                            )
                                          },
                                          expression: "contact.password"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: [
                                            this.contact.password ===
                                              this.contact
                                                .confirmationPassword ||
                                              "Las contraseñas no coinciden"
                                          ],
                                          "append-icon": _vm.showConfirmationPassword
                                            ? "mdi-eye"
                                            : "mdi-eye-off",
                                          type: _vm.showConfirmationPassword
                                            ? "text"
                                            : "password",
                                          label: "Confirmación de contraseña",
                                          disabled:
                                            !_vm.contact.password ||
                                            _vm.contact.password === " ",
                                          counter: "",
                                          maxlength: "30",
                                          required: "",
                                          autocomplete: "off",
                                          "prepend-icon": "mdi-account-lock"
                                        },
                                        on: {
                                          "click:append": function($event) {
                                            _vm.showConfirmationPassword = !_vm.showConfirmationPassword
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.contact.confirmationPassword,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.contact,
                                              "confirmationPassword",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "contact.confirmationPassword"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      this.IS_CONTACT_ADMINISTRATOR &&
                      !_vm.isUpdatingWithoutUser
                        ? _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "v-col",
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    "v-label",
                                    { staticClass: "text-center mx-auto" },
                                    [
                                      _vm._v(
                                        "¿Desea que el contacto tenga el perfil de SuperUsuario, es decir, pueda modificar datos y privilegios de otros contactos?"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-radio-group",
                                    {
                                      staticClass: "mx-auto",
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.isContactAdministrator,
                                        callback: function($$v) {
                                          _vm.isContactAdministrator = $$v
                                        },
                                        expression: "isContactAdministrator"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          attrs: {
                                            "no-gutters": "",
                                            justify: "center"
                                          }
                                        },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Sí",
                                              color: "#60BB46",
                                              value: true
                                            },
                                            on: {
                                              click: function() {
                                                if (
                                                  !this$1.isContactAdministrator
                                                ) {
                                                  this$1.$refs.privilegeConfirmationModal.openModal()
                                                }
                                              }
                                            }
                                          }),
                                          _c("v-radio", {
                                            attrs: {
                                              label: "No",
                                              value: false,
                                              color: "#60BB46"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { justify: "end" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "white--text mr-2",
                  attrs: { color: "green", outlined: "" },
                  on: {
                    click: function() {
                      this$1.$router.push({
                        name: this$1.LAST_ROUTE,
                        params: { canceled: true }
                      })
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "white--text mr-2",
                  attrs: { color: "green" },
                  on: { click: _vm.sendButton.action }
                },
                [
                  _c("v-icon", { staticClass: "ml-1" }, [
                    _vm._v("mdi-check-all")
                  ]),
                  _vm._v(" " + _vm._s(_vm.sendButton.text) + " ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: {
            top: "",
            fixed: "",
            timeout: 5000,
            color: _vm.snackbarColor
          },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: { click: _vm.closeSnackbar }
            },
            [_vm._v(" Cerrar ")]
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600px" },
          model: {
            value: _vm.displayContactExistsDialog,
            callback: function($$v) {
              _vm.displayContactExistsDialog = $$v
            },
            expression: "displayContactExistsDialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "div",
                { staticClass: "modal-title white--text d-flex align-center" },
                [
                  _c("h2", { staticClass: "font-weight-regular ma-2" }, [
                    _vm._v(
                      " Confirmación de " +
                        _vm._s(
                          !this.isUpdating || !this.isCreatingUser
                            ? "el registro"
                            : "la modificación"
                        ) +
                        " de contacto "
                    )
                  ])
                ]
              ),
              _c(
                "v-card-title",
                {
                  staticClass: "text-center font-weight-light",
                  staticStyle: { "word-break": "break-word" }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.contactExistDialogText) +
                      ", ¿Desea continuar " +
                      _vm._s(
                        !this.isUpdating || !this.isCreatingUser
                          ? "el registro"
                          : "la modificación"
                      ) +
                      " ? "
                  )
                ]
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text mr-4",
                      attrs: { color: "green" },
                      on: {
                        click: function() {
                          this$1.displayContactExistsDialog = false
                          this$1.allowRepeatedCi = true
                          this$1.sendButton.action()
                        }
                      }
                    },
                    [_vm._v("Sí")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text mr-7",
                      attrs: { color: "green" },
                      on: {
                        click: function($event) {
                          _vm.displayContactExistsDialog = false
                        }
                      }
                    },
                    [_vm._v("No")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "base-modal",
        {
          ref: "privilegeConfirmationModal",
          attrs: {
            icon: "mdi-alert-outline",
            title: "Confirmación de autorización"
          }
        },
        [
          _c(
            "v-col",
            [
              _c("div", { staticClass: "logout-question px-4 py-6" }, [
                _vm._v(" ¿Está seguro de otorgar privilegios de SuperUsuario? ")
              ]),
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "mr-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "", color: "green", dark: "" },
                          on: {
                            click: function() {
                              this$1.isContactAdministrator = true
                              this$1.$refs.privilegeConfirmationModal.closeModal()
                            }
                          }
                        },
                        [_vm._v("SÍ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "", outlined: "", color: "green" },
                          on: {
                            click: function() {
                              this$1.isContactAdministrator = false
                              this$1.$refs.privilegeConfirmationModal.closeModal()
                            }
                          }
                        },
                        [_vm._v("NO")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }